const videos = [
  {
    title: '某顶流演唱会后台花絮曝光',
    views: '128万',
    duration: '03:25',
    img: 'https://readdy.ai/api/search-image?query=Concert%20backstage%20illustration%20with%20warm%20stage%20lights%20and%20musical%20instruments%2C%20behind%20the%20scenes%20atmosphere%2C%20editorial%20flat%20vector%20style%2C%20coral%20and%20amber%20color%20palette%2C%20soft%20glowing%20effect%2C%20modern%20entertainment%20theme&width=600&height=400&seq=media-01&orientation=landscape',
  },
  {
    title: '综艺录制现场即兴爆笑名场面',
    views: '96万',
    duration: '05:12',
    img: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20studio%20illustration%20with%20colorful%20set%20design%20and%20laughing%20audience%2C%20bright%20warm%20lighting%2C%20editorial%20flat%20vector%20style%2C%20funny%20entertainment%20vibe%2C%20coral%20and%20amber%20accents%2C%20clean%20composition&width=600&height=400&seq=media-02&orientation=landscape',
  },
  {
    title: '网红直播翻车名场面合集',
    views: '205万',
    duration: '08:40',
    img: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20illustration%20with%20ring%20light%20and%20smartphone%20setup%2C%20dramatic%20reaction%20moment%2C%20editorial%20flat%20vector%20style%2C%20warm%20coral%20tones%2C%20social%20media%20personality%20vibe%2C%20modern%20clean%20design&width=600&height=400&seq=media-03&orientation=landscape',
  },
  {
    title: '年度红毯高光时刻混剪回顾',
    views: '167万',
    duration: '06:15',
    img: 'https://readdy.ai/api/search-image?query=Red%20carpet%20event%20illustration%20with%20elegant%20fashion%20silhouettes%20and%20camera%20flashes%2C%20glamorous%20atmosphere%2C%20editorial%20flat%20vector%20style%2C%20warm%20amber%20spotlights%2C%20sophisticated%20award%20show%20feel%2C%20clean%20modern%20design&width=600&height=400&seq=media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-2">
          吃瓜短视频集锦
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">热门娱乐短视频精选，轻松刷不停</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {videos.map((video, i) => (
            <div key={i} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200/50 transition-all">
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={video.img}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/15 group-hover:bg-black/5 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-1.5 py-0.5 bg-black/60 text-background-50 text-xs rounded">
                  {video.duration}
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug">{video.title}</h3>
                <p className="mt-1.5 text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-play-circle-line"></i> {video.views}次播放
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}